import DraperPlayer from "./DraperPlayer";
import * as React from 'react'

export interface VideoContextType {
    muted: boolean
    activeActivePlayer: DraperPlayer
    activePassivePlayer: DraperPlayer
    fullScreen: boolean
    updateContext: (newContext: VideoContextType) => void
}

export const videoContextDefaultValue: VideoContextType = {
    muted: true,
    activeActivePlayer: null,
    activePassivePlayer: null,
    fullScreen: false,
    updateContext: null
}

export const VideoContext = React.createContext(videoContextDefaultValue)